/* eslint-disable  */
import { Autocomplete, LoadingPlaceholder } from 'components';
import PactometroCheck from 'components/pactometro-si-no/checks';
import useDebounce from 'dataProvider/hooks/useDebounce';
import usePlacesProvider from 'dataProvider/hooks/usePlacesProvider';
import { TYPES } from 'envs';
import React, { Fragment, useEffect, useState } from 'react';
import './dashboard.scss';
import { excludedGrandParentIds } from 'core/constants';
import useResultProvider from 'dataProvider/hooks/useResultProvider';

const year = 2024;
const site = window.location.href.includes('lasexta') ? 'lasexta' : 'antena3';
const mode = window.location.href.includes('picadores')
  ? 'picadores'
  : 'normal';
const options = {
  lasexta: {
    option1: 'Pactómetro con abstención',
    option2: 'Pactómetro sin abstención'
  },
  antena3: {
    1100: '1100',
    4000: '4000'
  }
};

const BackupAutonomicas = ({ type = 'REGIONAL' }) => {
  const [modalInfo, setModalInfo] = useState(null);
  const [selectedOption, setSelectedOption] = useState(
    site === 'lasexta' ? 'option1' : '1100'
  );
  const [community, setCommunity] = useState('R16');
  const [province, setProvince] = useState(null);
  const [town, setTown] = useState(null);
  const [showModal, setShowModal] = useState(false); // Estado para controlar la visibilidad del modal

  const [autocompleReg, setAutocompleReg] = useState('');
  const [autocompleProv, setAutocompleProv] = useState('');
  const [autocompleMun, setAutocompleMun] = useState('');
  // const [subtype, setSubtype] = useState('CONGRESS');
  const [subtype, setSubtype] = useState('SINGLE');

  const [firebaseData, setFirebaseData] = useState({});

  const { result: dataPlacesRegion } = usePlacesProvider({
    type: 'REGION',
    sortby: 'name',
    excludedGrandParentIds: excludedGrandParentIds,
    electionType: type
  });

  const { result: dataPlacesProvince } = usePlacesProvider({
    type: 'PROVINCE',
    sortby: 'name',
    parentId: community,
    excludedGrandParentIds: [],
    electionType: type
  });

  const debouncedSearch = useDebounce(autocompleMun, 400);

  const { result: dataPlacesTown } = usePlacesProvider({
    sortby: 'name',
    name: debouncedSearch,
    type: 'TOWN',
    grandParentId: community,
    size: 10,
    excludedGrandParentIds: [],
    includedIds: []
  });

  const { result: dataResult } = useResultProvider({
    active: true,
    year,
    type,
    subtype: mode === 'picadores' ? subtype : 'SINGLE',
    electionNumber: 1,
    electionPlace: 'R16',
    placeId: town || province || community,
    details: Boolean(town),
    site,
    isBackupTV: true
  });

  useEffect(() => {
    setFirebaseData(prev => ({ ...prev, data: dataResult }));
  }, [dataResult]);

  useEffect(() => {
    let placeName = '';
    if (town) {
      placeName = dataPlacesTown?.find(t => t.ineId === town)?.name;
    } else if (province) {
      placeName = dataPlacesProvince?.find(p => p.ineId === province)?.name;
    } else {
      placeName = dataPlacesRegion?.find(r => r.ineId === community)?.name;
    }
    setFirebaseData({
      selectedOption,
      electionType: type,
      grandpaId: community,
      placeId: town || province || community,
      placeName,
      data: firebaseData.data
    });
  }, [
    selectedOption,
    type,
    community,
    province,
    town,
    dataPlacesTown,
    dataPlacesProvince,
    dataPlacesRegion
  ]);

  const handleSendDataToBackup = () => {
    let path = '';
    //TODO: funcion que usan los picadores nos tendrá que decir Óscar donde
    if (type === TYPES.REGIONAL) {
      const paths = {
        R02: '/api/elections/regionals/aragon/update',
        R03: '/api/elections/regionals/asturias/update',
        R04: '/api/elections/regionals/baleares/update',
        R06: '/api/elections/regionals/cantabria/update',
        R07: '/api/elections/regionals/castillalamancha/update',
        R10: '/api/elections/regionals/cvalenciana/update',
        R11: '/api/elections/regionals/extremadura/update',
        R12: '/api/elections/regionals/galicia/update',
        R13: '/api/elections/regionals/madrid/update',
        R14: '/api/elections/regionals/murcia/update',
        R15: '/api/elections/regionals/navarra/update',
        R16: '/api/elections/regionals/euskadi/update',
        R05: '/api/elections/regionals/canarias/update'
      };
      path = paths[community];
    } else if (type === TYPES.MUNICIPAL) {
      path = `/api/elections/municipales/update`;
    } else {
      // AQUI
      if (subtype === 'CONGRESS') {
        path = `/api/elections/generals/congress/update`;
      } else {
        path = `/api/elections/generals/senate/update`;
      }
    }
    if (!path) return;
    fetch(path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...firebaseData.data,
        updateDate: new Date().getTime()
      }) // Asegúrate de que dataResult esté definido correctamente
    })
      .then(() => {
        setModalInfo({
          title: 'Datos enviados correctamente',
          text: 'Los datos se han enviado correctamente a la base de datos'
        });
        console.log("datos", firebaseData.data)
        console.log("datos enviados a:", path)
        setShowModal(true);
      })
      .catch(err => {
        alert(err);
      });
  };

  const handleSendData = () => {
    // console.log('firebaseData', {
    //   ...firebaseData,
    //   selectedsYes,
    //   selectedsNo,
    //   selectedsAbs,
    //   placeId: 'C108',
    //   subtype: 'CONGRESS'
    // });
    const data = {
      selectedsYes: selectedsYes,
      selectedsNo: selectedsNo,
      selectedsAbs: selectedsAbs,
      placeId: 'R16',
      subtype: 'SINGLE',
      selectedOption: firebaseData.selectedOption
    };
    fetch('http://interdesfront2.antena3tv.es:3005/send-tv-info', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data) // Asegúrate de que dataResult esté definido correctamente
    })
      .then(() => {
        setModalInfo({
          title: 'Datos enviados correctamente',
          text: 'Los datos se han enviado correctamente a la base de datos'
        });
        setShowModal(true);
      })
      .catch(err => {
        alert(err);
      });
  };

  const handleSendDataFirebase = () => {
    fetch('http://interdesfront2.antena3tv.es:3005/send-backup-data', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...firebaseData,
        placeId: 'R16',
        subtype: 'SINGLE'
      }) // Asegúrate de que dataResult esté definido correctamente
    })
      .then(() => {
        setModalInfo({
          title: 'Datos enviados correctamente',
          text: 'Los datos se han enviado correctamente a la base de datos'
        });
        setShowModal(true);
      })
      .catch(err => {
        alert(err);
      });
  };

  const handleConfirm = () => {
    setShowModal(false); // Cerrar el modal de confirmación
    handleSendData(); // Llamar a la función para enviar los datos
  };
  const handleConfirmFirebase = () => {
    setShowModal(false); // Cerrar el modal de confirmación
    handleSendDataFirebase(); // Llamar a la función para enviar los datos
  };

  const handleConfirmBackup = () => {
    setShowModal(false); // Cerrar el modal de confirmación
    handleSendDataToBackup(); // Llamar a la función para enviar los datos
  };

  const handleChangeCommunity = (e, select) => {
    e.preventDefault();
    setCommunity(select.ineId);
    setProvince(null);
    setTown(null);
  };

  const handleChangeProvince = (e, select) => {
    e.preventDefault();
    if (community === null) {
      setCommunity(select.parentId);
      // setCommunity(dataPlacesRegion.find(reg => reg.ineId === select.parentId));
    }
    setProvince(select.ineId);
    setTown(null);
  };

  const handleChangeTown = (e, select) => {
    e.preventDefault();
    setCommunity(select.grandpaId);
    setProvince(select.parentId);
    setTown(select.ineId);
  };

  const handleOptionChange = event => {
    setSelectedOption(event.target.value);
  };

  const handleCleanSelection = () => {
    setCommunity(null);
    setProvince(null);
    setTown(null);
  };

  // Función para abrir el modal
  const openModal = modalInfoData => {
    setModalInfo(modalInfoData);
    setShowModal(true);
  };

  // Función para cerrar el modal
  const closeModal = () => {
    setShowModal(false);
  };

  const openModalConfirm = () => {
    openModal({
      title: 'Confirmar el envío de datos',
      description: '¿Estás seguro de que quieres enviar los datos?',
      confirmText: 'Enviar',
      cancelText: 'Cancelar',
      handleConfirm
    });
  };

  const openModalConfirmBackup = () => {
    openModal({
      title: 'Confirmar el envío de datos',
      description:
        '¿Estás seguro de que quieres enviar los datos a la base de datos?',
      confirmText: 'Enviar',
      cancelText: 'Cancelar',
      handleConfirm: handleConfirmBackup
    });
  };

  const openModalConfirmSendData = () => {
    openModal({
      title: 'Confirmar el envío de datos',
      description: '¿Estás seguro de que quieres enviar los datos a firebase?',
      confirmText: 'Enviar',
      cancelText: 'Cancelar',
      handleConfirm: handleConfirmFirebase
    });
  };
  const filterData = dataResult?.partiesResult?.filter(
    current => current.seats >= 1
  );

  useEffect(() => {
    setSelectedsAbs(
      dataResult?.partiesResult?.filter(current => current.seats >= 1)
    );
  }, [dataResult]);

  const [selectedsYes, setSelectedsYes] = useState([]);
  const [selectedsNo, setSelectedsNo] = useState([]);
  const [selectedsAbs, setSelectedsAbs] = useState([]);

  if (!dataPlacesRegion || !dataPlacesProvince || !dataPlacesTown) {
    return <LoadingPlaceholder />;
  }

  return (
    <div className="dashboard-panel">
      <h1>Backup manual</h1>
      {/* Modal de confirmación */}
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            <h2>{modalInfo?.title}</h2>
            <p>{modalInfo?.description}</p>
            <div>
              {modalInfo?.handleConfirm && (
                <button onClick={modalInfo?.handleConfirm}>
                  {modalInfo?.confirmText}
                </button>
              )}
              <button onClick={closeModal}>
                {modalInfo?.closeText || 'Cerrar'}
              </button>
            </div>
          </div>
        </div>
      )}

      <Fragment>
        {mode === 'normal' && (
          <>
            {site === 'lasexta' && (
              <>
                <div className="row">
                  <label>
                    <input
                      type="radio"
                      value="option1"
                      checked={selectedOption === 'option1'}
                      onChange={handleOptionChange}
                    />
                    Pactómetro con abstención
                  </label>

                  <label>
                    <input
                      type="radio"
                      value="option2"
                      checked={selectedOption === 'option2'}
                      onChange={handleOptionChange}
                    />
                    Pactómetro sin abstención
                  </label>
                </div>
                <section className="PactosSiNo">
                  <div className="pactosScrollContent">
                    <PactometroCheck
                      data={filterData}
                      selecteds={selectedsYes}
                      selectedsNo={selectedsNo}
                      selectedId={true}
                      onChange={event => {
                        if (event.pacto === 1) {
                          setSelectedsYes([...selectedsYes, event.item]);
                          if (selectedsNo.includes(event.item)) {
                            setSelectedsNo(
                              selectedsNo.filter(
                                item => item.id !== event.item.id
                              )
                            );
                          }

                          if (selectedsAbs.includes(event.item)) {
                            setSelectedsAbs(
                              selectedsAbs.filter(
                                item => item.id !== event.item.id
                              )
                            );
                          }
                        } else if (event.pacto === 0) {
                          setSelectedsNo([...selectedsNo, event.item]);
                          if (selectedsYes.includes(event.item)) {
                            setSelectedsYes(
                              selectedsYes.filter(
                                item => item.id !== event.item.id
                              )
                            );
                          }
                          if (selectedsAbs.includes(event.item)) {
                            setSelectedsAbs(
                              selectedsAbs.filter(
                                item => item.id !== event.item.id
                              )
                            );
                          }
                        } else {
                          setSelectedsAbs([...selectedsAbs, event.item]);
                          if (selectedsYes.includes(event.item)) {
                            setSelectedsYes(
                              selectedsYes.filter(
                                item => item.id !== event.item.id
                              )
                            );
                          }
                          if (selectedsNo.includes(event.item)) {
                            setSelectedsNo(
                              selectedsNo.filter(
                                item => item.id !== event.item.id
                              )
                            );
                          }
                        }
                      }}
                    />
                  </div>
                </section>
              </>
            )}
          </>
        )}

        {mode === 'picadores' && (
          <div className="row">
            {/* <div className="m10 w200">
              <label>
                <input
                  type="radio"
                  value="CONGRESS"
                  checked={subtype === 'CONGRESS'}
                  onChange={() => setSubtype('CONGRESS')}
                />
                Congreso
              </label>
              <br />
              <label>
                <input
                  type="radio"
                  value="SENATE"
                  checked={subtype === 'SENATE'}
                  onChange={() => setSubtype('SENATE')}
                />
                Senado
              </label>
            </div> */}

            <div className="m10 w200">
              <Autocomplete
                results={
                  autocompleReg
                    ? dataPlacesRegion.filter(reg => {
                        return reg.name
                          .toLowerCase()
                          .includes(autocompleReg.toLowerCase());
                      })
                    : dataPlacesRegion
                }
                onChange={e => {
                  setAutocompleReg(e);
                }}
                onSelect={handleChangeCommunity}
                placeholder="Buscar comunidad"
                showArrow
                defaultValue={community}
                type={type}
                year={year}
              />
            </div>

            {/* <div className="m10 w200">
              <Autocomplete
                results={
                  autocompleProv
                    ? dataPlacesProvince.filter(prov => {
                        return prov.name
                          .toLowerCase()
                          .includes(autocompleProv.toLowerCase());
                      })
                    : dataPlacesProvince
                }
                onSelect={handleChangeProvince}
                onChange={e => {
                  setAutocompleProv(e);
                }}
                placeholder="Buscar provincia"
                showArrow
                defaultValue={province}
                type={type}
                year={year}
              />
            </div>

            <div className="m10 w200">
              <Autocomplete
                results={dataPlacesTown}
                onChange={value => setAutocompleMun(value)}
                onSelect={handleChangeTown}
                placeholder="Buscar municipio"
                showArrow
                type={type}
                defaultValue={town}
                year={year}
              />
            </div> */}

            <div className="m10 w200">
              <button onClick={handleCleanSelection}>Limpiar seleccion</button>
            </div>
          </div>
        )}
      </Fragment>
      {mode === 'normal' && site === 'lasexta' && (
        <>
          <small>
            Este botón confirma que datos salen en{' '}
            {options[site][selectedOption]}
          </small>
          <div className="row">
            <button
              style={{
                width: '250px'
              }}
              onClick={openModalConfirm}
            >
              Enviar a {options[site][selectedOption]}
            </button>
          </div>
        </>
      )}
      <div></div>
      <Fragment>
        {firebaseData?.data && firebaseData?.data?.partiesResult && (
          <>
            <table>
              <thead>
                <tr>
                  <th>Dato</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Porcentaje</td>
                  <td>
                    <input
                      type="number"
                      value={firebaseData?.data?.currentCountPercent}
                      onChange={e => {
                        setFirebaseData({
                          ...firebaseData,
                          data: {
                            ...firebaseData.data,
                            currentCountPercent: e.target.value
                          }
                        });
                      }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <table>
              <thead>
                <tr>
                  <th>Partido</th>
                  <th>Escaños</th>
                </tr>
              </thead>
              <tbody>
                {firebaseData?.data?.partiesResult.map((party, i) => (
                  <tr key={party.id}>
                    <td>{party.partyAcronym}</td>
                    <td>
                      <input
                        type="number"
                        data-id={party.id}
                        value={party.seats}
                        // onChange={updateJSON}
                        onChange={e => {
                          setFirebaseData({
                            ...firebaseData,
                            data: {
                              ...firebaseData.data,
                              partiesResult:
                                firebaseData.data.partiesResult.map(
                                  (p, index) => {
                                    if (index === i) {
                                      return {
                                        ...p,
                                        seats: e.target.value
                                      };
                                    }
                                    return p;
                                  }
                                )
                            }
                          });
                        }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {mode === 'normal' ? (
              <>
                <small>Este botón cambia los datos España </small>
                <div className="row">
                  <button
                    style={{
                      width: '250px'
                    }}
                    onClick={openModalConfirmSendData}
                  >
                    Pisar datos manualmente
                  </button>
                </div>
              </>
            ) : (
              <div className="row">
                <button
                  style={{
                    width: '250px'
                  }}
                  onClick={openModalConfirmBackup}
                >
                  ENVIAR DATOS AL BACKUP
                </button>
              </div>
            )}
          </>
        )}
      </Fragment>
    </div>
  );
};

export default BackupAutonomicas;
